/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import Body from 'DesignSystem/Body/index'
import React from 'react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/Topbar/Sms/StatusTooltip/Content"
  
}) {
  let isBefore = useIsBefore()
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--o-2-Z1Yf8zk': isBefore ? 0 : 1,'--t-1-Z1Yf8zk': isBefore ? "20px" : "24px"}}
 className={`views-block ${styles.Vertical}`}
>
<Body
  viewPath={`${viewPath}/Body`}
 fontSize={12}
 text="Text Message Thread (Not secured)"
 lineHeight={1}
/>
</div>
{children}
</React.Fragment>)
}